import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_PUBLIC_PAYMENT_INFO_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetPaymentInfoRequestPayload,
  GetPaymentInfoResult,
  PaymentStatusInfo,
} from '../types/getPaymentInfo.types';

export const PAYMENTS_PUBLIC_INFO = 'PaymentPublicInfo';
export const getPublicPaymentInfo = (builder: BuilderType) =>
  builder.query<PaymentStatusInfo, GetPaymentInfoRequestPayload>({
    providesTags: [PAYMENTS_PUBLIC_INFO],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PAYMENTS_PUBLIC_PAYMENT_INFO_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPaymentInfoResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result.PaymentInfo;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
